import { render, staticRenderFns } from "./AddEditTrailer.vue?vue&type=template&id=4795e317&scoped=true&"
import script from "./AddEditTrailer.vue?vue&type=script&lang=js&"
export * from "./AddEditTrailer.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTrailer.vue?vue&type=style&index=0&id=4795e317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795e317",
  null
  
)

export default component.exports